import Vue from 'vue'
import App from './App.vue'
import router from './router/index.js'
import store from './store/index.js'

import { COOKIE_MODAL_ID } from './config/environment'

import { localHostNames } from '@/config'

import 'vue-advanced-cropper/dist/style.css'

import bugsnag from '@bugsnag/js'
import bugsnagVue from '@bugsnag/plugin-vue'
import '@mdi/font/css/materialdesignicons.css'

import Vuetify, {
  VApp,
  VAppBar,
  VNavigationDrawer,
  VToolbar,
  VToolbarTitle,
  VContent,
  VIcon,
  VBtn,
  VList,
  VListGroup,
  VCard,
  VCardTitle,
  VCardActions,
  VCardText,
  VSpacer,
  VContainer,
  VSnackbar,
  VProgressLinear,
  VLayout,
  VFlex,
  VFadeTransition,
  VSlideXTransition,
  VSlideYTransition,
  VDataIterator,
  VDataTable,
  VAlert,
  VEditDialog,
  VTextField,
  VCheckbox,
  VMenu,
  VChip,
  VForm,
  VProgressCircular,
  VTooltip,
  VAutocomplete,
  VSelect,
  VSpeedDial,
  VExpansionPanels,
  VExpansionPanelContent,
  VExpansionPanelHeader,
  VExpansionPanel,
  VDivider,
  VDatePicker,
  VTabs,
  VTabsItems,
  VTabsSlider,
  VTabItem,
  VTab,
  VSwitch,
  VDialog,
  VTextarea,
  VTimePicker,
  VCombobox,
  VStepper,
  VStepperStep,
  VStepperContent,
  VImg,
  VOverlay,
  VRow,
  VCol,
  VBadge,
  VTimeline,
  VTimelineItem,
  VRadioGroup,
  VRadio,
} from 'vuetify/lib'
import en from 'vuetify/es5/locale/en'
import es from 'vuetify/es5/locale/es'
import { Ripple } from 'vuetify/lib/directives'
import 'vuetify/dist/vuetify.min.css'

import { i18n } from './locale'

import MultiFiltersPlugin from './plugins/MultiFilters'

import VueResource from 'vue-resource'

import IdleVue from 'idle-vue'

import VueSignaturePad from 'vue-signature-pad'

import { ErrorManager } from './services/error.service'
const errorManager = new ErrorManager()

var pjson = require('../package.json')

Vue.config.productionTip = false

const bugsnagClient = bugsnag({ apiKey: '354966e47b5c36e3076f580a61c7d233', appVersion: pjson.version })
bugsnagClient.use(bugsnagVue, Vue)

const vuetifyOpts = {
  lang: {
    locales: { en, es },
    current: (navigator.language || navigator.userLanguage).split('-')[0] === 'es' ? 'es' : 'en',
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        primary: {
          lighten2: '#E6FFFF',
          lighten1: '#241DBA',
          base: '#00D7D7',
          darken1: '#009999',
          darken2: '#003333',
        },
        secondary: {
          lighten2: '#EAE9FC',
          lighten1: '#9591EE',
          darken1: '#16116E',
          darken2: '#09072C',
          base: '#040729',
        },
        error: '#D32F2F',
        warning: {
          lighten: '#FCD8B2',
          base: '#FCA64E',
          darken: '#D37B20',
        },
        accent: {
          lighten1: '#00D7D7',
          base: '#00D7D7',
          darken1: '#040729',
        },
      },
    },
  },
}

Vue.use(Vuetify, {
  components: {
    VApp,
    VAppBar,
    VNavigationDrawer,
    VToolbar,
    VToolbarTitle,
    VContent,
    VIcon,
    VBtn,
    VList,
    VListGroup,
    VCard,
    VCardTitle,
    VCardActions,
    VCardText,
    VSpacer,
    VContainer,
    VSnackbar,
    VProgressLinear,
    VLayout,
    VFlex,
    VFadeTransition,
    VSlideXTransition,
    VSlideYTransition,
    VDataIterator,
    VDataTable,
    VAlert,
    VEditDialog,
    VTextField,
    VCheckbox,
    VMenu,
    VChip,
    VForm,
    VProgressCircular,
    VTooltip,
    VAutocomplete,
    VSelect,
    VSpeedDial,
    VExpansionPanels,
    VExpansionPanelContent,
    VExpansionPanelHeader,
    VExpansionPanel,
    VDivider,
    VDatePicker,
    VTabs,
    VTabsItems,
    VTabsSlider,
    VTabItem,
    VTab,
    VSwitch,
    VDialog,
    VTextarea,
    VTimePicker,
    VCombobox,
    VStepper,
    VStepperStep,
    VStepperContent,
    VImg,
    VOverlay,
    VRow,
    VCol,
    VBadge,
    VTimeline,
    VTimelineItem,
    VRadioGroup,
    VRadio,
  },
  directives: {
    Ripple,
  },
})

Vue.use(MultiFiltersPlugin)

Vue.use(VueResource)
Vue.http.interceptor.before = function (request, next) {
  store.commit('state/setLoading', true)
  next(response => {
    if (!response.ok) {
      errorManager.manageError(response, request.disableStatusHandling)
    }
    store.commit('state/setLoading', false)
  })
}

Vue.use(IdleVue, {
  store,
  idleTime: 1000,
  startAtIdle: false,
})

Vue.use(VueSignaturePad)

new Vue({
  router,
  store,
  vuetify: new Vuetify(vuetifyOpts),
  i18n,
  render: h => h(App),
}).$mount('#app')

if (!localHostNames.includes(location.hostname)) {
  var head = document.getElementsByTagName('head')[0]
  let js = document.createElement('script')
  js.src = 'https://consent.cookiebot.com/uc.js'
  js.setAttribute('data-cbid', COOKIE_MODAL_ID)
  js.setAttribute('data-blockingmode', 'auto')
  js.type = 'text/javascript'
  js.id = 'Cookiebot'
  head.appendChild(js)
}
